// routes/config/authRoutes.ts
/**
 * Auth Route Configuration
 * Login, reset password, and authentication-related routes
 */

import { lazy } from 'react';
import { ROUTES } from '../../config/routes';
import type { RouteConfig } from '../types';

const LoginPage = lazy(() => import('../../features/auth/pages/LoginPage'));
const ResetPasswordPage = lazy(() => import('../../features/auth/pages/ResetPasswordPage'));
const InvitePage = lazy(() => import('../../features/auth/pages/InvitePage'));

export const authRoutes: RouteConfig[] = [
  {
    path: ROUTES.LOGIN,
    element: LoginPage,
    auth: 'public', // Redirect if already authenticated
  },
  {
    path: ROUTES.RESET_PASSWORD,
    element: ResetPasswordPage,
    auth: 'open', // No auth required
  },
  {
    path: ROUTES.INVITE,
    element: InvitePage,
    auth: 'open', // No auth required - invite links work for anyone
  },
];
